import { useTranslation } from 'react-i18next';
import { useContent } from '../contexts/ContentContext';

export const FinalCTA = () => {
  const { t } = useTranslation();
  const { getValue } = useContent();

  const scrollToForm = () => {
    document.getElementById('form')?.scrollIntoView({ behavior: 'smooth' });
  };

  const title = getValue('cta.title', t('cta.title'));
  const subtitle = getValue('cta.subtitle', t('cta.subtitle'));
  const button = getValue('cta.button', t('cta.button'));

  return (
    <section className="py-14 animate-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-[36px] border border-white/15 bg-[linear-gradient(135deg,rgba(40,80,245,0.28)_0%,rgba(91,63,246,0.24)_40%,rgba(192,60,247,0.22)_100%)] px-6 py-12 text-center shadow-[0_50px_120px_-60px_rgba(12,14,44,0.75)]">
          <h2 className="text-2xl md:text-3xl font-extrabold text-white drop-shadow">{title}</h2>
          <p className="text-white/80 mt-3 max-w-2xl mx-auto">{subtitle}</p>
          <button
            onClick={scrollToForm}
            className="mt-8 inline-flex justify-center items-center rounded-2xl border border-transparent px-6 py-3 font-semibold bg-regai-accent text-white shadow-lg hover:bg-regai transition-colors"
          >
          {button}
          </button>
        </div>
      </div>
    </section>
  );
};
